import { generateUuid } from '../helpers/strings';
import { TrackingHandler } from '../tracking/TrackingHandler';
import { detectFormTest } from '../helpers/detect-form-test';
import { captchaWidgets, resetCaptcha } from '../helpers/captchas';
import { log } from '../tracking/InternalLogger';
import { navigateToUrl } from '../helpers/navigation';
import { ConsentFormHandlerFactory } from '../forms/consent-form-handler/ConsentFormHandlerFactory';
export const getFormName = (formContainer) => {
    return formContainer.dataset.formName || 'undefined';
};
export const addTrackingData = (data) => {
    const trackingData = TrackingHandler.getInstance().getAllTrackingData();
    data.visit_id_c = trackingData.visitId;
    data.visitor_id_c = trackingData.visitorId;
    data.vtuid_c = trackingData.visitorId;
    data.origin_source_c = trackingData.source;
    data.origin_medium_c = trackingData.medium;
    data.origin_campaign_c = trackingData.campaign;
    data.origin_details_c = JSON.stringify(trackingData.originDetails);
    data.page_url_c = trackingData.currentUrl;
    data.referral_code_c = trackingData.referralCode;
    data.fingerprint_c = trackingData.fingerprint;
    if (typeof data.product_c !== 'string' || data.product_c.length === 0) {
        data.product_c = trackingData.pageProduct;
    }
    return data;
};
const startCaptcha = (formContainer) => {
    const captchaContainer = formContainer.querySelector('.captcha-container');
    if (!captchaContainer || !captchaContainer.id || !captchaWidgets.has(captchaContainer.id)) {
        return;
    }
    const widget = captchaWidgets.get(captchaContainer.id);
    widget.start();
};
const startFormCallback = (callbackData) => {
    const formName = getFormName(callbackData.formContainer);
    const formInput = callbackData.event.target.name;
    TrackingHandler.getInstance().formStart(formName, formInput);
    startCaptcha(callbackData.formContainer);
};
const navigateFormCallback = (callbackData) => {
    const formName = getFormName(callbackData.formContainer);
    let navigationAction = 'goto';
    if (callbackData.requestedStepNumber === callbackData.currentStepNumber - 1) {
        navigationAction = 'previous';
    }
    else if (callbackData.requestedStepNumber === callbackData.currentStepNumber + 1) {
        navigationAction = 'next';
    }
    if (!detectFormTest(callbackData.data)) {
        TrackingHandler.getInstance().formNavigate(formName, callbackData.requestedStepNumber, navigationAction, callbackData.data);
    }
    startCaptcha(callbackData.formContainer);
    return true;
};
const submitModifierCallback = (callbackData) => {
    const data = callbackData.data;
    data.form_name_c = getFormName(callbackData.formContainer);
    if (!callbackData.formContainer.dataset.submitId) {
        callbackData.formContainer.dataset.submitId = generateUuid().replace(/-/g, '');
    }
    data.submit_id_c = callbackData.formContainer.dataset.submitId;
    return addTrackingData(data);
};
const submitFormCallback = (callbackData) => {
    const formName = getFormName(callbackData.formContainer);
    if (!detectFormTest(callbackData.data)) {
        TrackingHandler.getInstance().formSubmit(formName, callbackData.data);
    }
    return true;
};
const submitResultCallback = (callbackData) => {
    log('Form submit result', {
        formName: getFormName(callbackData.formContainer),
        status: callbackData.xhr.status,
        isTest: detectFormTest(callbackData.data),
    });
    const isSuccess = callbackData.xhr.status >= 200 && callbackData.xhr.status < 300;
    const consentGiven = callbackData.data.consentdataprocess_c === 'TRUE';
    if (isSuccess && !consentGiven) {
        const consentFormHandler = ConsentFormHandlerFactory.getInstance().getHandler();
        if (consentFormHandler) {
            consentFormHandler.displayConsentForm(callbackData.data.submit_id_c, callbackData.formContainer);
        }
    }
    if (!isSuccess) {
        const captchaContainer = callbackData.formContainer.querySelector('.captcha-container');
        if (captchaContainer) {
            resetCaptcha(captchaContainer);
        }
        return true;
    }
    if (callbackData.formContainer.dataset.successPage) {
        navigateToUrl(callbackData.formContainer.dataset.successPage);
        return false;
    }
    return true;
};
export const generalCallbacks = {
    startFormCallback,
    navigateFormCallback,
    submitModifierCallback,
    submitFormCallback,
    submitResultCallback,
};
